import { EID_REPORT } from "constants/actionTypes";

import { offlineActionCreator, passthroughSerializer } from "./lib";

interface EIDReportUrlParams {
  ids?: string[];
  forceStaff?: boolean;
  // requestOne passes { id } — support single-EID fallback
  id?: string;
}

const eidReportUrlCreator = ({ ids, id, forceStaff }: EIDReportUrlParams) => {
  const eids = ids ?? (id ? [id] : []);
  const eidsParam = eids.map(eid => encodeURIComponent(eid)).join(",");
  const staffParam = forceStaff ? "&staff=true" : "";
  return `/v2/eid/report?EIDs=${eidsParam}${staffParam}`;
};

export const EIDReportAction = offlineActionCreator(
  EID_REPORT,
  passthroughSerializer,
  eidReportUrlCreator,
  false,
);
